<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Dodaj novog servisera za infrastrukturu</h2>
    </div>
    <div class="body">
      <div id="first-section">
        <div class="first-item">
          <label class="col-form-label col-form-label-lg">
            Naziv
            <span class="mandatory">*</span>
          </label>
          <model-select
            ref="municipality"
            :options="contractors"
            v-model="selectedContractor"
            placeholder="
            Izaberite servisera"
            class="muni-dropdown add-member-dropdown"
            @input="onContractorChange()"
          ></model-select>
        </div>
        <div class="second-item">
          <label class="col-form-label col-form-label-lg">
            Kontakt osoba
          </label>
          <model-select
            ref="municipality"
            :options="contacts"
            v-model="selectedContact"
            placeholder="
            Izaberite kontakt osobu"
            class="muni-dropdown add-member-dropdown"
          ></model-select>
        </div>
      </div>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="addInfrastructureContractor"
        >
          <p v-if="!loading">Dodaj novog servisera za infrastrukturu</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import debounce from 'debounce';
import { ModelSelect } from 'vue-search-select';

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      loading: false,
      contractors: [],
      contacts: [],
      selectedContact: null,
      selectedContractor: null
    };
  },
  async created() {
    const contractorsResult = await this.getAllContractors(false);
    this.contractors = contractorsResult.map(cat => {
      cat.value = cat;
      cat.text = cat.name;
      return {
        value: cat,
        text: cat.name
      };
    });
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'removeInfrastructure']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getAllContractors', 'getInfrastructureById']),
    async onContractorChange() {
      try {
        const id = this.selectedContractor.value.id;
        if (id) {
          const result = await axios.get(`/contractor/${id}`);
          this.contacts = result.data.contractor.contacts.map(con => {
            return {
              text: `${con.name} (${con.phone})`,
              value: con.id
            };
          });
          this.selectedContact = null;
        }
      } catch (error) {
        this.selectedContact = null;
        this.selectedContractor = null;
      }
    },
    async addInfrastructureContractor() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      let data = {
        memberId: this.$store.getters.getActiveCommunity.member_id,
        contractors: [
          {
            contractorId: this.selectedContractor.value.id,
            contractorContactId: this.selectedContact
          }
        ]
      };
      try {
        await axios.post(
          `infrastructure/${
            this.$store.state.modal.infrastructure.id
          }/contractor`,
          data
        );
        // await this.getAllContractors();
        await this.getInfrastructureById(
          this.$store.state.modal.infrastructure.id
        );
        this.loading = false;
        this.removeInfrastructure();
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.showFailModal();
      }

      //   financesInstance
      //     .post(`communities/${this.$route.params.id}/member`, virtualMemberData)
      //     .then(async () => {
      //       const virtualMembers = await this.getAllMembersForCommunityFinances(
      //         this.$route.params.id
      //       );
      //       this.setVirtualMembersList(virtualMembers);
      //       this.loading = false;
      //       this.closeModal();
      //       this.showSuccessModal();
      //     })
      //     .catch(error => {
      //       this.loading = false;
      //       console.log(error);
      //       this.showFailModal();
      //     });
    },
    validateInput() {
      if (!this.selectedContractor) {
        this.errorMessage = 'Morate izabrati servisera';
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
#upload-area {
  display: block;
  margin-left: 9px;
  width: 100%;
  height: 100%;
  text-align: center;
}

#uploaded-files {
  border: 1px dotted var(--primary-color);
  border-radius: 0.25rem;
  height: 110px;
  resize: none;
  max-height: 134px;
  overflow-y: auto;
  padding: 5px;
}
.file {
  border-bottom: solid 1px lightgray;
  font-size: 15px;
  width: 100%;
  display: inline-flex;
  vertical-align: center;
  p {
    text-align: left;
    word-break: break-word;
    margin-bottom: 2px;
  }
  i {
    margin-left: 4px;
  }
}
.del--mod {
  margin-left: auto;
  /*margin-right: 0;*/
  cursor: pointer;
  color: red;
  top: 4.7em;
  right: 1.7em;
}
.upload-more-wrapper {
  width: 30%;
  margin: 0 auto;
}
#empty-files {
  text-align: center;
  color: grey;
  margin-top: 15%;
}
.user--mod {
  .text {
    max-width: calc(100% - 30px) !important;
  }
}
.address-search {
  height: calc(2.25rem + 5px) !important;
  input {
    font-size: 1rem !important;
  }
  item {
    font-size: 1rem !important;
  }
}
.list-no-border {
  border: none !important;
}
.modal-content-virtual-member {
  .add-new-contact {
    margin-left: 0 !important;
    // margin-top: 16px;
  }
  .contacts {
    padding: 8px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    margin-bottom: 16px;
    span.btn-primary {
      width: 4rem;
      min-width: 25px;
    }
  }
  .address-wrapper {
    display: flex;
    .address-street {
      flex: 3;
    }
    .address-number {
      flex: 1;
      margin-left: 16px;
      input {
        height: calc(2.25rem + 5px) !important;
      }
    }
    .first-item {
      flex: 1;
    }
    .second-item {
      flex: 1;
      margin-left: 16px;
    }
  }
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .address-search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        // input {
        //   border: none;
        //   padding: 0.5rem 1rem;
        //   font-size: 1rem;
        //   line-height: 1;
        //   max-width: 100%;
        // }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
